<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>
                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <a-divider> ارسال پیامک</a-divider>

                              <div class="col-md-12 my-1">
                                    <div class="form-group ">
                                        <label class="sr-only" for="inline-form-input-name">
                                            منطقه ارسال</label>
                                        <a-tree-select v-model="info.area_id" show-search style="width: 100%"
                                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                            placeholder="انتخاب استان و شهر  " allow-clear
                                            tree-default-expand-all>
                                            <a-icon slot="suffixIcon" type="smile" />
                                            <a-tree-select-node v-for="state in states" :key="'state' + state.id" :disabled="true"
                                                :value="'state' + state.id" :title="state.name">
                                                <a-tree-select-node v-for="city in state.cities" :key="'city' + city.id" 
                                                    :value="'city' + city.id" :title="city.name" />    
                                            </a-tree-select-node>
                                        </a-tree-select>
                                    </div>
                                </div>

                                  

                        

                            <div class="col-md-12 my-5">
                                <div class="form-group ">
                                    <label>متن پیامک </label>
                                    <b-form-textarea id="textarea"  placeholder="توضیحات ..."
                                        rows="3" max-rows="6"></b-form-textarea>
                                </div>

                            </div>

                            


                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100" :disabled="!$root.hasPermission('/send/sms/')">
                                        ذخیره
                                    </button>
                                </div>
                                
                                <div class="col-md-1 ">
                                    <router-link to="/categories/list" class="btn btn-fill btn-outline-danger w-100">
                                        بازگشت</router-link>
                                </div>

                            </div>

                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: {},
                parents:[],
                states: [],
            };
        },
       
        methods: {
          
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                _this.$root.loading = true;
                let url = '/products/states';

                axios
                    .get(url)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success(" پیامک با موفقیت در صف ارسال قرار داده شد");
            
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
               async getStates() {
                let _this = this;
                let url = '/products/states';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.states = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
        mounted(){
                        this.getStates();

        }
    };
</script>
